import { ContentCard } from '../../components/ContentCard/ContentCard';
import { Icon, close } from '../../components/Icon/Icon';
import { Modal } from '../../components/Modal/Modal';
import { useTranslation } from '../../i18n/i18n';
import { useState } from 'react';
import { Button } from '../Form/Button';
import './EditAddressModal.css';

export const EditAddressModal = ({
	children,
	onSave,
	disabled,
}: {
	children: string | JSX.Element | JSX.Element[];
	onSave: () => void;
	disabled: boolean;
}) => {
	const [open, setOpen] = useState(false);
	const t = {
		...useTranslation().orderPages,
		communication: useTranslation().communication,
	};

	return (
		<>
			<Button style={{ marginBottom: '1.6rem' }} onClick={() => setOpen(true)}>
				{t.edit}
			</Button>

			<Modal
				className="edit-address-modal"
				show={open}
				disableBodyScroll
				onDismiss={() => setOpen(false)}
				toggle={() => setOpen((prev) => !prev)}
			>
				<ContentCard className="edit-address-content">
					<button className="close-btn" onClick={() => setOpen(false)}>
						<Icon shape={{ ...close, fill: 'black' }} size={20} />
					</button>

					{children}

					<Button
						disabled={disabled}
						onClick={() => {
							onSave();
							setOpen(false);
						}}
					>
						{t.communication.saveChanges}
					</Button>
				</ContentCard>
			</Modal>
		</>
	);
};
